import React, { useEffect, useState } from 'react';
import { Button, ButtonGroup, Col, Container, Form, Row, Spinner, Table } from 'react-bootstrap';
import { connect } from 'react-redux';
import { apiUrl, businessName } from '../../utils/consts';
import { formatMoney } from '../../utils/formatMoney';
import { withRouter } from 'react-router';
import moment from 'moment';
import './styles/adminBenefits.scss';

const select = state => {
  return {
    userId: state.auth.userId,
    token: state.auth.token
  };
};

function ConnectedAdminBenefits(props) {

  const { token, userId } = props;

  const [loading, setLoading] = useState(true);
  const [benefits, setBenefits] = useState([]);
  const [tab, setTab] = useState(0);
  const [typeFilter, setTypeFilter] = useState('ALL');

  const benefitsToShow = typeFilter === 'ALL' ? benefits : benefits.filter(item => item.benefitType === typeFilter);

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    setLoading(true);

    const benefitsProm = await fetch(`${apiUrl}/benefits/get/admin`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        userId,
        token,
        businessName
      })
    });

    const benefitsResp = await benefitsProm.json();

    if (benefitsResp.success) setBenefits(benefitsResp.benefits);

    setLoading(false);
  };

  if (loading) {
    return (
      <div className="user-benefits-component">
        <div className="center">
          <Spinner variant="primary" animation="grow" />
        </div>
      </div>
    );
  }

  return (
    <div className="user-benefits-component">
      <Container>
        <Row>
          <Col>
            <h1>Muro de la solidaridad</h1>

            <ButtonGroup>
              <Button variant={tab === 0 ? 'secondary' : 'outline-secondary'} onClick={() => setTab(0)}>
                Aprobadas
              </Button>
              <Button variant={tab === 1 ? 'secondary' : 'outline-secondary'} onClick={() => setTab(1)}>
                Por aprobar
              </Button>
            </ButtonGroup>

            <Row>
              <Form.Group as={Col} md={4}>
                <Form.Label className="app-label">Tipo</Form.Label>
                <Form.Control
                  as="select"
                  value={typeFilter}
                  onChange={event => setTypeFilter(event.target.value)}
                >
                  <option value="ALL">Todas</option>
                  <option value="COUPON">Bonos</option>
                  <option value="CUSTOM">Ayudas particulares</option>
                </Form.Control>
              </Form.Group>
            </Row>

            {
              tab === 0 ?
              <Table striped bordered hover size="sm">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Tipo</th>
                    <th>Categoría</th>
                    <th>Fecha de creación</th>
                    <th>Estado</th>
                    <th>Monto</th>
                    <th>Nombre</th>
                    <th style={{ textAlign: 'center' }}>Opciones</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    benefitsToShow.filter(item => item.status !== 'PENDING').map((benefit, index) =>
                      <tr key={benefit._id}>
                        <td>{index + 1}</td>
                        {
                          benefit.benefitType === 'CUSTOM' ?
                          <>
                            <td>Ayuda particular</td>
                            <td>-</td>
                          </> :
                          <>
                            <td>Bono</td>
                            <td>{benefit.category}</td>
                          </>
                        }
                        <td>{moment(benefit.dateCreated).format('YYYY-MM-DD')}</td>
                        <td>
                          {
                            benefit.status === 'PENDING' ? 'Pendiente' :
                            benefit.status === 'AVAILABLE' ? 'Disponible' :
                            benefit.status === 'DECLINED' ? 'Rechazada' :
                            'Asignada'
                          }
                        </td>
                        {
                          benefit.benefitType === 'CUSTOM' ?
                          <>
                            <td>-</td>
                            <td>{benefit.name}</td>
                          </> :
                          <>
                            <td>{formatMoney(Math.floor(benefit.amount))}</td>
                            <td>-</td>
                          </>
                        }
                        {
                          benefit.benefitType === 'CUSTOM' ?
                          <td className="options">
                            <Button className="edit-btn" variant="info" onClick={() => props.history.push(`/ayudas/${benefit._id}`)}>
                              Ver
                            </Button>
                          </td> :
                          <td></td>
                        }
                      </tr>
                    )
                  }
                </tbody>
              </Table> :
              <Table striped bordered hover size="sm">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Tipo</th>
                    <th>Categoría</th>
                    <th>Fecha de creación</th>
                    <th>Estado</th>
                    <th>Monto</th>
                    <th>Nombre</th>
                    <th style={{ textAlign: 'center' }}>Opciones</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    benefitsToShow.filter(item => item.status === 'PENDING').map((benefit, index) =>
                      <tr key={benefit._id}>
                        <td>{index + 1}</td>
                        {
                          benefit.benefitType === 'CUSTOM' ?
                          <>
                            <td>Ayuda particular</td>
                            <td>-</td>
                          </> :
                          <>
                            <td>Bono</td>
                            <td>{benefit.category}</td>
                          </>
                        }
                        <td>{moment(benefit.dateCreated).format('YYYY-MM-DD')}</td>
                        <td>
                          {
                            benefit.status === 'PENDING' ? 'Pendiente' :
                            benefit.status === 'AVAILABLE' ? 'Disponible' :
                            benefit.status === 'DECLINED' ? 'Rechazada' :
                            'Asignada'
                          }
                        </td>
                        {
                          benefit.benefitType === 'CUSTOM' ?
                          <>
                            <td>-</td>
                            <td>{benefit.name}</td>
                          </> :
                          <>
                            <td>{formatMoney(Math.floor(benefit.amount))}</td>
                            <td>-</td>
                          </>
                        }
                        {
                          benefit.benefitType === 'CUSTOM' ?
                          <td className="options">
                            <Button
                              className="edit-btn"
                              variant="info"
                              onClick={() => props.history.push(`/ayudas/${benefit._id}`)}
                            >
                              Ver
                            </Button>
                          </td> :
                          <td></td>
                        }
                      </tr>
                    )
                  }
                </tbody>
              </Table>
            }
          </Col>
        </Row>
      </Container>
    </div>
  );
}

const AdminBenefits = connect(select)(ConnectedAdminBenefits);

export default withRouter(AdminBenefits);
